<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    calculatePercentage() {
      return (this.progress / this.limit) * 100;
    },
    progressBarColor() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878'
        ? 'linear-gradient(90deg, #ff6e69 -33.33%, #ff6e69 100%)'
        : 'linear-gradient(90deg, #55bcf5 -33.33%, #4059e1 100%)';
    },
  },
};
</script>

<template>
  <div class="container-progress-bar">
    <div class="progress-bar" :style="{ width: calculatePercentage + '%', background: progressBarColor }"> </div>
    <label>{{ progress + '/' + limit }}</label>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.container-progress-bar {
  background: rgba(222, 222, 222, 0.38);
  border-radius: 20px;
  height: 6px;
  position: relative;
  width: auto;

  .progress-bar {
    background: linear-gradient(90deg, #55bcf5 -33.33%, #4059e1 100%);
    border-radius: 8px;
    height: 100%;
    text-align: center;
  }

  label {
    color: #c4c4c4;
    float: right;
    font-family: $secondary-font-family;
    font-size: 14px;
    letter-spacing: 1px;
    margin-top: 12px;
  }
}
</style>
